<template>
    <div>
        <h1 v-if="!this.siteName && !forDenomination && !forFinder && !websiteFocus">{{ $t('register.header') }}</h1>
        <h1 v-if="!this.siteName && !forDenomination && !forFinder && websiteFocus">
            {{ $t('register.headerWebsite') }}
        </h1>
        <h1 v-if="!this.siteName && !forDenomination && forFinder">{{ $t('register.headerFinder') }}</h1>
        <h1 v-if="!this.siteName && forDenomination && !websiteFocus">
            {{ updateAdminOnly ? $t('register.headerDenominationUpdateAdmin') : $t('register.headerDenomination') }}
            {{ denominationName }}
        </h1>
        <h1 v-if="!this.siteName && forDenomination && websiteFocus">
            {{ $t('register.headerDenominationWebsite') }}
            {{ denominationName }}
        </h1>
        <h1 v-if="this.siteName">{{ $t('register.headerinstanceavailable') }}</h1>
        <form class="ct-register-form ct-card form-horizontal" v-on:keyup.enter="sendRegistration()">
            <Language></Language>

            <section v-if="useStandardPortal && websiteFocus">
                <div class="ct-input-element" style="margin-top: 8rem;">
                    <h4 style="text-align: center">{{ $t('label.alreadyCustomer') }}</h4>
                </div>
                <div class="ct-input-element">
                    <div
                        class="ct-hint"
                        style="white-space: unset; color: #333;"
                        v-html="$t('hint.startTestphaseFromChurchTools')"
                    ></div>
                </div>
                <div v-if="cwbKircheHamburg" class="ct-input-element">
                    <div
                        class="ct-hint"
                        style="white-space: unset; color: #333;"
                        v-html="$t('hint.contactSupportForCWBKircheHamburg')"
                    ></div>
                </div>
            </section>
            <section v-if="useStandardPortal && !websiteFocus">
                <h3>{{ $t('label.niceHeader') }}</h3>
                <text-area
                    :config="{
                        translationKey: 'label.problemHeader',
                        required: true,
                        id: 'problem',
                        type: 'text',
                        maxlength: 255,
                        rows: 3
                    }"
                    :input-model.sync="register.problem"
                    :error="getError('problem')"
                    v-on:resetValidation="resetValidation('problem')"
                ></text-area>
                <div class="ct-input-element">
                    <div class="ct-hint" style="white-space: unset" v-html="$t('label.problemDescription')"></div>
                </div>
                <div v-if="register.registrationLanguage === 'de' || register.registrationLanguage === 'de-kr'">
                    <div class="ct-input-element">
                        <div class="checkbox">
                            <label for="just-looking">
                                <input
                                    name="checkjustlooking"
                                    type="checkbox"
                                    v-model="justLooking"
                                    id="just-looking"
                                />
                                <span v-html="$t('label.justLooking')"></span>
                            </label>
                        </div>
                    </div>
                    <div v-if="justLooking" class="ct-input-element">
                        <div
                            class="ct-hint"
                            style="white-space: unset"
                            v-html="$t('label.justLookingDescription')"
                        ></div>
                    </div>
                    <div v-if="justLooking" class="ct-input-element">
                        <button
                            class="btn btn-primary btn-lg btn-block"
                            type="button"
                            v-on:click="jumpToDemo($t('link.demo'))"
                        >
                            {{ $t('button.demo') }}
                        </button>
                    </div>
                </div>
            </section>
            <section v-if="useStandardPortal && !websiteFocus" class="ct-border"></section>
            <section :style="mainSectionStyle">
                <h3 v-if="useStandardPortal && !websiteFocus">{{ $t('label.andNowAFewDetails') }}</h3>
                <h3 v-if="useStandardPortal && !websiteFocus" style="text-align: right">
                    {{ $t('label.detailsAboutYourChurch') }}
                </h3>
                <h3 v-if="useStandardPortal && websiteFocus">{{ $t('label.notYetCustomer') }}</h3>
                <h3 v-if="!useStandardPortal">{{ $t('label.churchinformationDenomination') }}</h3>
                <div class="ct-input-element" v-if="useStandardPortal && websiteFocus">
                    <div class="ct-hint" style="white-space: unset" v-html="$t('hint.freeCombo')"></div>
                </div>
                <div v-if="!updateAdminOnly">
                    <text-input
                        v-if="!cwbKircheHamburg"
                        :config="{ translationKey: 'label.churchname', required: true, id: 'church-name' }"
                        :input-model.sync="register.churchName"
                        :error="getError('churchName')"
                        v-on:resetValidation="resetValidation('churchName')"
                    ></text-input>
                    <select-input
                        v-if="cwbKircheHamburg"
                        :config="{
                            translationKey: 'label.churchname',
                            required: true,
                            id: 'church-name'
                        }"
                        :options="kircheHamburgChurchesOptions"
                        :input-model.sync="register.churchName"
                        :error="getError('churchName')"
                        v-on:resetValidation="resetValidation('churchName')"
                    ></select-input>
                    <text-input
                        v-if="cwbNordkirche && !cwbKircheHamburg"
                        :config="{
                            translationKey: 'label.institutionId',
                            required: false,
                            id: 'institutionId',
                            hint: 'hint.institutionId'
                        }"
                        :input-model.sync="register.institutionId"
                        :error="getError('institutionId')"
                        v-on:resetValidation="resetValidation('institutionId')"
                    ></text-input>
                    <text-input
                        :config="{ translationKey: 'label.city', required: true, id: 'city' }"
                        :input-model.sync="register.city"
                        :error="getError('city')"
                        v-on:resetValidation="resetValidation('city')"
                    ></text-input>
                    <div class="ct-row two-elements">
                        <select-input
                            :config="{
                                translationKey: 'label.countrycode',
                                required: true,
                                id: 'country-code',
                                prefix: 'countries',
                                preferredOptions: preferredCountries
                            }"
                            :options="countries"
                            :input-model.sync="register.countryCode"
                            :error="getError('countryCode')"
                            v-on:resetValidation="resetValidation('countryCode')"
                        ></select-input>
                        <select-input
                            :config="{
                                translationKey: 'label.baselanguage.short',
                                required: true,
                                id: 'base-language',
                                prefix: 'languages',
                                hint: 'label.baselanguage.long'
                            }"
                            :options="dropdownLanguages"
                            :input-model.sync="register.baseLanguage"
                            :error="getError('baseLanguage')"
                            v-on:resetValidation="resetValidation('baseLanguage')"
                            :pre-select="register.registrationLanguage"
                        ></select-input>
                    </div>
                    <text-input
                        :config="{
                            translationKey: websiteFocus ? 'label.currentWebsite' : 'label.website',
                            id: 'website'
                        }"
                        :input-model.sync="register.website"
                        :error="getError('website')"
                        v-on:resetValidation="resetValidation('website')"
                    ></text-input>
                </div>
                <check-input
                    :config="getDomainConfig()"
                    :input-model.sync="register.siteName"
                    :error="getError('siteName')"
                    :icon="checkIcon"
                    :iconClass="checkIconClass"
                ></check-input>
            </section>
            <section v-if="!createSiteOnly" class="ct-border">
                <h3 v-if="useStandardPortal && websiteFocus">{{ $t('label.contactperson') }}</h3>
                <h3 v-if="useStandardPortal && !websiteFocus" style="text-align: right">
                    {{ $t('label.detailsAboutYou') }}
                </h3>
                <h3 v-if="!useStandardPortal">{{ $t('label.contactpersonDenomination') }}</h3>
                <select-input
                    :config="{
                        translationKey: 'hint.appellation',
                        required: true,
                        id: 'appellation',
                        prefix: 'appellation'
                    }"
                    :options="appellationOptions"
                    :input-model.sync="register.appellation"
                    :error="getError('appellation')"
                ></select-input>
                <div class="ct-row two-elements">
                    <text-input
                        :config="{ translationKey: 'label.firstname', required: true, id: 'firstname' }"
                        :input-model.sync="register.firstName"
                        :error="getError('firstName')"
                        v-on:resetValidation="resetValidation('firstName')"
                    ></text-input>
                    <text-input
                        :config="{ translationKey: 'label.lastname', required: true, id: 'lastname' }"
                        :input-model.sync="register.lastName"
                        :error="getError('lastName')"
                        v-on:resetValidation="resetValidation('lastName')"
                    ></text-input>
                </div>
                <text-input
                    :config="{ translationKey: 'label.email', required: true, id: 'email' }"
                    :input-model.sync="register.email"
                    :error="getError('email')"
                    v-on:resetValidation="resetValidation('email')"
                ></text-input>
                <phone-input
                    v-if="useStandardPortal"
                    :config="{ translationKey: 'label.phone', required: true, id: 'phone' }"
                    :input-model.sync="register.phone"
                    :error="getError('phone')"
                    v-on:resetValidation="resetValidation('phone')"
                    :country="register.countryCode"
                ></phone-input>
            </section>
            <section v-if="!createSiteOnly" class="ct-border ct-small-text">
                <select-input
                    v-if="!forDenomination"
                    :config="{
                        translationKey: 'hint.heardfrom',
                        required: true,
                        id: 'heard-from',
                        prefix: 'heardfrom'
                    }"
                    :options="heardFromOptions"
                    :input-model.sync="register.heardFrom"
                    :error="getError('heardFrom')"
                    :preSelect="heardFromPreselect"
                    v-on:resetValidation="resetValidation('heardFrom')"
                ></select-input>
                <text-input
                    v-if="!forDenomination"
                    :config="{ translationKey: 'label.discountcode', id: 'discountcode', hint: 'hint.discountcode' }"
                    :input-model.sync="register.discountCode"
                    :hide="!showDiscountCode"
                ></text-input>
                <div class="ct-input-element">
                    <div class="checkbox">
                        <label for="newsletter-check">
                            <input
                                name="checknewsletter"
                                type="checkbox"
                                v-model="register.checknewsletter"
                                id="newsletter-check"
                            />
                            <span v-if="useStandardPortal" v-html="$t('label.checknewsletter')"></span>
                            <span v-if="!useStandardPortal" v-html="$t('label.checknewsletterDenomination')"></span>
                        </label>
                    </div>
                </div>
                <div class="ct-input-element" v-if="useStandardPortal">
                    <div
                        class="checkbox"
                        :class="{ 'has-error': showValidationsErrors['checkagbs'] && !register.checkagbs }"
                    >
                        <label for="agb-check">
                            <input name="checkagbs" type="checkbox" v-model="register.checkagbs" id="agb-check" />
                            <span v-html="$t('label.checkagbs', { link: agb_link })"></span>
                        </label>
                        <span
                            class="help-block has-error"
                            v-show="showValidationsErrors['checkagbs'] && !register.checkagbs"
                            >{{ getError('checkagbs') }}</span
                        >
                    </div>
                </div>
                <div class="ct-input-element" v-if="useStandardPortal">
                    <div
                        class="checkbox"
                        :class="{ 'has-error': showValidationsErrors['checkgdpr'] && !register.checkgdpr }"
                    >
                        <label for="gdpr-check">
                            <input name="checkgdpr" type="checkbox" v-model="register.checkgdpr" id="gdpr-check" />
                            <span v-html="$t('label.checkgdpr', { link: gdpr_link })"></span>
                        </label>
                        <span
                            class="help-block has-error"
                            v-show="showValidationsErrors['checkgdpr'] && !register.checkgdpr"
                            >{{ getError('checkgdpr') }}</span
                        >
                    </div>
                </div>
            </section>
            <section v-if="allowSetupService" class="ct-border">
                <h3>{{ $t('label.setupService') }}</h3>
                <div class="ct-input-element">
                    <div class="ct-hint" style="white-space: unset">
                        {{
                            setupServiceMandatory && hasSetupMeetingOptions
                                ? $t('hint.setupServiceMandatory')
                                : $t('hint.setupServiceOptional')
                        }}
                    </div>
                </div>
                <div class="ct-input-element" v-if="!setupServiceMandatory">
                    <div class="checkbox">
                        <label for="setup-service-check">
                            <input
                                name="checksetupservice"
                                type="checkbox"
                                v-model="register.withSetupService"
                                id="setup-service-check"
                            />
                            <span v-html="$t('label.useSetupService')"></span>
                        </label>
                    </div>
                </div>
                <select-input
                    v-if="register.withSetupService"
                    :config="{
                        translationKey: 'label.setupMeeting',
                        required: true,
                        id: 'setupMeetingDate',
                        noSort: true
                    }"
                    :options="setupMeetingOptions"
                    :input-model.sync="register.setupMeetingDate"
                    :error="getError('setupMeetingDate')"
                ></select-input>
            </section>
            <section v-if="showWebsiteCheckbox" class="ct-border">
                <h3>{{ $t('label.churchtoolsWebsite') }}</h3>
                <div class="ct-input-element">
                    <div class="ct-hint" style="white-space: unset" v-html="$t('hint.churchtoolsWebsite')"></div>
                </div>
                <div class="ct-input-element">
                    <div class="checkbox">
                        <label for="website-check">
                            <input
                                name="checkwithwebsite"
                                type="checkbox"
                                v-model="register.withWebsite"
                                id="website-check"
                            />
                            <span v-html="$t('label.registerWebsite')"></span>
                        </label>
                    </div>
                </div>
            </section>
            <section class="ct-action">
                <div class="ct-input-element">
                    <button
                        class="btn btn-primary btn-lg btn-block"
                        type="button"
                        v-on:click="sendRegistration()"
                        :disabled="registering"
                    >
                        {{ registering ? $t('button.registering') : $t('button.register') }}
                    </button>
                </div>
                <div class="ct-input-element" v-if="useStandardPortal && !forFinder">
                    <div class="ct-hint">{{ registrationHint }}</div>
                </div>
            </section>
        </form>
    </div>
</template>
<script>
import * as types from '../store/mutation-types';
import Vue from 'vue';
import TextInput from '../components/inputs/TextInput.vue';
import TextArea from '../components/inputs/TextArea.vue';
import SelectInput from '../components/inputs/SelectInput.vue';
import CheckInput from '../components/inputs/CheckInput.vue';
import PhoneInput from '../components/inputs/PhoneInput.vue';
import moment from 'moment';
import Language from '../components/language/Language.vue';
import kircheHamburgChurches from './kircheHamburgChurches';

export default {
    props: ['language', 'cta', 'siteName', 'inKRZRoute', 'setupServiceMandatory'],
    data: function() {
        return {
            register: {
                problem: '',
                churchName: '',
                city: '',
                countryCode: '',
                website: '',
                siteName: this.siteName ? this.siteName : '',
                baseLanguage: 'de',
                appellation: 'mr',
                email: '',
                phone: '',
                discountCode: '',
                heardFrom: denomination !== '' ? 'denomination' : '',
                comment: '',
                firstName: '',
                lastName: '',
                checkagbs: false,
                checkgdpr: false,
                checknewsletter: false,
                registrationLanguage: this.$i18n.locale,
                cta: '',
                denomination: denomination !== '' ? this.cta : '',
                standardPortal: !!standardPortal,
                createSiteOnly: !!createSiteOnly,
                updateAdminOnly: !!updateAdminOnly,
                cwbKircheHamburg: !!cwbKircheHamburg,
                cwbNordkirche: !!cwbNordkirche,
                inKRZ: !!inKRZ || !!this.inKRZRoute,
                setupServiceMandatory: this.setupServiceMandatory,
                withSetupService: this.setupServiceMandatory,
                setupMeetingDate: 0,
                withWebsite: false,
                isPilot: false,
                institutionId: ''
            },
            justLooking: false,
            checkIcon: '',
            checkIconClass: '',
            dropdownLanguages: ['de', 'en', 'pt'],
            appellationOptions: ['mrs', 'mr', 'not_specified'],
            heardFromOptions: [
                'friend',
                'church',
                'google',
                'facebook',
                'instagram',
                'capterra',
                'magazine',
                'conference',
                'other'
            ],
            preferredCountries: ['DE', 'GB', 'BR', 'US'],
            countries: [
                'AF',
                'EG',
                'AX',
                'AL',
                'DZ',
                'AS',
                'VI',
                'AD',
                'AO',
                'AI',
                'AQ',
                'AG',
                'GQ',
                'AR',
                'AM',
                'AW',
                'AC',
                'AZ',
                'ET',
                'AU',
                'BS',
                'BH',
                'BD',
                'BB',
                'BE',
                'BZ',
                'BJ',
                'BM',
                'BT',
                'BO',
                'BA',
                'BW',
                'BV',
                'VG',
                'IO',
                'BN',
                'BG',
                'BF',
                'BI',
                'CL',
                'CN',
                'CK',
                'CR',
                'DK',
                'SH',
                'DG',
                'DM',
                'DO',
                'DJ',
                'EC',
                'SV',
                'ER',
                'EE',
                'EU',
                'FK',
                'FO',
                'FJ',
                'FI',
                'FR',
                'GF',
                'PF',
                'TF',
                'GA',
                'GM',
                'GE',
                'GH',
                'GI',
                'GD',
                'GR',
                'GL',
                'GP',
                'GU',
                'GT',
                'GG',
                'GN',
                'GW',
                'GY',
                'HT',
                'HM',
                'HN',
                'HK',
                'IN',
                'ID',
                'IQ',
                'IR',
                'IE',
                'IS',
                'IM',
                'IL',
                'IT',
                'JM',
                'JP',
                'YE',
                'JE',
                'JO',
                'KY',
                'KH',
                'CM',
                'CA',
                'IC',
                'CV',
                'KZ',
                'QA',
                'KE',
                'KG',
                'KI',
                'CC',
                'CO',
                'KM',
                'CD',
                'HR',
                'CU',
                'KW',
                'LA',
                'LS',
                'LV',
                'LB',
                'LR',
                'LY',
                'LI',
                'LT',
                'LU',
                'MO',
                'MG',
                'MW',
                'MY',
                'MV',
                'ML',
                'MT',
                'MA',
                'MH',
                'MQ',
                'MR',
                'MU',
                'YT',
                'MK',
                'MX',
                'FM',
                'MD',
                'MC',
                'MN',
                'ME',
                'MS',
                'MZ',
                'MM',
                'NA',
                'NR',
                'NP',
                'NC',
                'NZ',
                'NT',
                'NI',
                'NL',
                'AN',
                'NE',
                'NG',
                'NU',
                'KP',
                'MP',
                'NF',
                'NO',
                'OM',
                'AT',
                'TL',
                'PK',
                'PS',
                'PW',
                'PA',
                'PG',
                'PY',
                'PE',
                'PH',
                'PN',
                'PL',
                'PT',
                'PR',
                'CI',
                'CG',
                'RE',
                'RW',
                'RO',
                'RU',
                'SB',
                'ZM',
                'WS',
                'SM',
                'ST',
                'SA',
                'SE',
                'CH',
                'SN',
                'RS',
                'CS',
                'SC',
                'SL',
                'ZW',
                'SG',
                'SK',
                'SI',
                'SO',
                'SU',
                'ES',
                'LK',
                'KN',
                'LC',
                'PM',
                'VC',
                'ZA',
                'SD',
                'GS',
                'KR',
                'SR',
                'SJ',
                'SZ',
                'SY',
                'TJ',
                'TW',
                'TZ',
                'TH',
                'TG',
                'TK',
                'TO',
                'TT',
                'TA',
                'TD',
                'CZ',
                'TN',
                'TR',
                'TM',
                'TC',
                'TV',
                'UG',
                'UA',
                'HU',
                'UY',
                'UZ',
                'VU',
                'VA',
                'VE',
                'AE',
                'VN',
                'WF',
                'CX',
                'BY',
                'EH',
                'CF',
                'CY'
            ],
            showDiscountCode: false,
            registering: false
        };
    },
    components: {
        TextInput,
        TextArea,
        SelectInput,
        CheckInput,
        PhoneInput,
        Language
    },
    computed: {
        agb_link: function() {
            return "<a target='_blank' href=\"" + this.$t('link.agbs') + '">' + this.$t('label.agbs') + '</a>';
        },
        gdpr_link: function() {
            return "<a target='_blank' href=\"" + this.$t('link.dataprivacy') + '">' + this.$t('label.gdpr') + '</a>';
        },
        validationErrors: function() {
            return this.$store.state.registrations.validationErrors;
        },
        showValidationsErrors: function() {
            return this.$store.getters['registrations/showValidationErrors'];
        },
        heardFromPreselect: function() {
            if (this.cta && this.cta.indexOf('cap') === 0) {
                return 'capterra';
            }
            return null;
        },
        denominationName: function() {
            return denomination;
        },
        forDenomination: function() {
            return denomination !== '';
        },
        forFinder: function() {
            return this.cta === 'finder';
        },
        useStandardPortal: function() {
            return !!standardPortal;
        },
        createSiteOnly: function() {
            return !!createSiteOnly;
        },
        updateAdminOnly: function() {
            return !!updateAdminOnly;
        },
        cwbKircheHamburg: function() {
            return !!cwbKircheHamburg;
        },
        cwbNordkirche: function() {
            return !!cwbNordkirche;
        },
        inKRZ: function() {
            return this.register.inKRZ;
        },
        setupMeetingOptions: function() {
            let meetings = this.$store.getters['registrations/setupMeetings'];
            let locale = this.$store.getters['getLanguage'];
            if (locale === 'de-krz') {
                locale = 'de';
            }
            return meetings.map(meeting => {
                moment.locale(locale);
                return {
                    value: meeting.id,
                    noTranslation: true,
                    label:
                        moment(meeting.date).format('ddd, DD.MM. HH:mm') +
                        ' (' +
                        this.$t('label.with') +
                        ' ' +
                        meeting.who +
                        ')'
                };
            });
        },
        hasSetupMeetingOptions: function() {
            return this.setupMeetingOptions.length > 0;
        },
        allowSetupService: function() {
            return (
                this.hasSetupMeetingOptions &&
                !this.createSiteOnly &&
                !this.updateAdminOnly &&
                !this.forDenomination &&
                this.register.baseLanguage === 'de' &&
                !this.websiteFocus
            );
        },
        showWebsiteCheckbox: function() {
            return !this.websiteFocus && this.register.baseLanguage === 'de' && !this.isForPublicPosts;
        },
        websiteFocus: function() {
            return this.cta ? this.cta.startsWith('cwb') && this.useStandardPortal : false;
        },
        isHamburgOst: function() {
            return this.cta ? this.cta.startsWith('cwbkkho') : false;
        },
        isForPublicPosts: function() {
            return this.cta ? this.cta.startsWith('publicposts') : false;
        },
        registrationHint: function() {
            return this.websiteFocus
                ? this.$t('hint.testWebsite')
                : this.register.withWebsite
                ? this.$t('hint.testChurchToolsPlusWebsite')
                : this.$t('hint.testChurchTools');
        },
        mainSectionStyle: function() {
            return this.websiteFocus ? 'border-top: 1px solid #dddddd; margin-top: 8rem;' : '';
        },
        kircheHamburgChurchesOptions: function() {
            return kircheHamburgChurches.churches.map(church => {
                return {
                    value: church.id,
                    label: church.name,
                    noTranslation: true
                };
            });
        }
    },
    mounted() {
        $(function() {
            $('[data-toggle="tooltip"]').tooltip();
        });
        if (this.register.inKRZ) {
            this.$store.commit(types.LANGUAGE_CHANGE, 'de-kr');
            this.register.registrationLanguage = 'de-kr';
        } else if (this.language) {
            this.$store.commit(types.LANGUAGE_CHANGE, this.language);
            this.register.registrationLanguage = this.language;
        }
        if (!this.register.inKRZ && this.register.registrationLanguage === 'de-kr') {
            this.$store.commit(types.LANGUAGE_CHANGE, 'de');
            this.register.registrationLanguage = 'de';
        }
        this.$store.dispatch('registrations/loadSetupMeetings');
    },
    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },
    watch: {
        'register.siteName': function() {
            if (this.register.siteName.length > 1) {
                let check = 'registrations/checkSiteName';
                if (this.updateAdminOnly) {
                    // update admin only: invert site name check
                    check = 'registrations/checkSiteNameExists';
                }
                this.$store
                    .dispatch(check, {
                        siteName: this.register.siteName,
                        denomination: this.register.denomination,
                        inKRZ: this.register.inKRZ
                    })
                    .then(() => {
                        this.checkIcon = 'check';
                        this.checkIconClass = 'ct-icon-border';
                    })
                    .catch(() => {
                        this.checkIcon = 'cancel';
                        this.checkIconClass = 'ct-icon-border-red';
                    });
            } else {
                this.checkIcon = '';
            }
        },
        'register.heardFrom': function() {
            this.showDiscountCode = this.register.heardFrom === 'conference' || this.register.heardFrom === 'magazine';
        },
        '$i18n.locale'(newValue) {
            this.register.registrationLanguage = newValue;
            this.setWithWebsite(newValue === 'de');
        }
    },
    methods: {
        resetValidation: function(fieldName) {
            this.$store.commit(`registrations/${types.HIDE_VALIDATION_ERROR}`, fieldName);
        },
        getError: function(fieldName) {
            if (this.showValidationsErrors[fieldName]) {
                return this.$i18n.t(
                    this.$store.state.registrations.validationErrors[fieldName].translationKey,
                    this.$store.state.registrations.validationErrors[fieldName].args
                );
            }

            return '';
        },
        getDomainConfig: function() {
            return {
                translationKey: 'label.instancename.short',
                required: true,
                id: 'site-name',
                hint: 'label.instancename.long',
                prefix: 'https://',
                suffix: this.register.inKRZ ? '.krz.tools' : '.church.tools'
            };
        },
        sendRegistration: function() {
            this.registering = true;
            this.register.siteName = this.register.siteName.toLowerCase();
            if (!this.allowSetupService) {
                this.register.setupServiceMandatory = false;
                this.register.withSetupService = false;
                this.register.setupMeetingDate = 0;
            } else {
                this.register.setupServiceMandatory = this.setupServiceMandatory && this.hasSetupMeetingOptions;
                if (this.register.setupServiceMandatory) {
                    this.register.withSetupService = true;
                } else {
                    if (!this.hasSetupMeetingOptions) {
                        this.register.withSetupService = false;
                        this.register.setupMeetingDate = 0;
                    }
                }
            }

            if (this.cta) {
                this.register.cta = this.cta;
            }
            if (this.websiteFocus) {
                this.register.withWebsite = true;
            }
            this.register.websiteFocus = this.websiteFocus;

            if (this.cwbKircheHamburg && this.register.churchName) {
                const church = kircheHamburgChurches.churches.find(church => {
                    return church.id === this.register.churchName;
                });
                if (church) {
                    this.register.churchName = church.name;
                    this.register.institutionId = church.id;
                    this.register.isPilot = church.pilot;
                }
            }

            this.$store
                .dispatch('registrations/register', { register: this.register })
                .then(resendToken => {
                    if (hasFacebookPixel) {
                        fbq('track', 'CompleteRegistration');
                    }
                    this.registering = false;
                    this.$router.push({ name: 'RegisterFinished', params: { token: resendToken } });
                })
                .catch(error => {
                    this.registering = false;
                    window.scrollTo(0, 0);
                });
        },
        setWithWebsite(checkboxValue) {
            this.register.withWebsite = checkboxValue;
        },
        jumpToDemo(location) {
            window.location = location;
        }
    }
};
</script>
